import { createApi } from '@reduxjs/toolkit/query/react';

import { baseCMSQueryWithReauth } from '@/shared/api/base-cms-query-with-reauth';

export const baseCMSApi = createApi({
    reducerPath: 'baseCMSApi',
    baseQuery: baseCMSQueryWithReauth,
    endpoints: () => ({}),
});
